import {Settings} from 'lucide-react';
import {useTranslation} from 'react-i18next';
import {useSearchParams} from 'react-router-dom';

import {Button} from '@/components/ui/button';
import {FormLabel} from '@/components/ui/form';

export type JobRoleFieldLabelProps = {
  label: string;
};

const JobRoleFieldLabel = ({label}: JobRoleFieldLabelProps) => {
  const {t} = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <div className="flex flex-row items-center gap-2">
      <FormLabel className="grow">{label}</FormLabel>
      <Button
        type="button"
        variant="default"
        size="small"
        onClick={() => {
          searchParams.set('manageJobRoles', 'true');
          setSearchParams(searchParams);
        }}
      >
        <Settings />
        {t('Manage job roles')}
      </Button>
    </div>
  );
};

export default JobRoleFieldLabel;
